// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ProductBadgeUpcLabel: React.FC<{
    size?: number;
    color1?: string;
    color2?: string;
    color3?: string;
    className?: string;
}> = ({ size = 18, color1 = "#fff", color2 = "#ccc", color3 = "#daa91c", className }) => (
    <svg className={className} focusable="false" viewBox="0 0 18 18" width={size} height={size}>
        <g fill="none" fillRule="evenodd">
            <rect width="18" height="18" fill={color1} rx="9" />
            <path
                fill={color2}
                fillRule="nonzero"
                d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0m0 .5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17"
            />
            <path
                fill={color3}
                fillRule="nonzero"
                d="M8.562 4.5c.35 0 .685.138.932.385l3.62 3.62a1.316 1.316 0 0 1 0 1.863l-2.746 2.746a1.316 1.316 0 0 1-1.861 0l-3.62-3.62a1.3 1.3 0 0 1-.387-.93V5.487c0-.546.442-.988.987-.988zM5.487 8.563a.33.33 0 0 0 .097.233l3.62 3.62a.33.33 0 0 0 .465 0l2.746-2.746a.33.33 0 0 0 0-.465l-3.62-3.62a.33.33 0 0 0-.233-.097H5.487zm1.317-2.417a.658.658 0 1 1 0 1.316.658.658 0 0 1 0-1.316"
            />
        </g>
    </svg>
);

export default React.memo(ProductBadgeUpcLabel);
